module.exports = __webpack_public_path__ + "static/media/uppropet2.1cbaa756.png";